'use client'

import Link from '@components/common/Link/Link'
import Module from '@components/modules'
import Button from '@components/ui/ButtonV2/Button'
import { useCustomer } from '@features/account/api/get-customer'
import { CustomerQuery } from '@lib/graphql/graphql'
import clsx from 'clsx'
import { signOut } from 'next-auth/react'
import { useRouter } from 'next/router'
import { FC, useEffect } from 'react'
import s from './M57GeneralComponent.module.scss'

type M57GeneralComponentProps = {
  modules: any
  customerInfo: CustomerQuery
}

const M57GeneralComponent: FC<M57GeneralComponentProps> = ({ ...props }) => {
  let { data } = useCustomer({})
  if (!data) data = props.customerInfo

  // set active link based on current page url (class .active on li element)
  const router = useRouter()
  const currentPath = router.asPath

  useEffect(() => {
    const links = document.querySelectorAll(`.${s.link}`)

    links.forEach((link) => {
      const href = link?.getAttribute('href')

      const normalizedHref = href?.replace(/\/$/, '')
      const normalizedPath = currentPath.replace(/\/$/, '')

      if (
        normalizedPath === normalizedHref ||
        (normalizedHref?.includes('/my-orders') &&
          normalizedPath?.includes('/order'))
      ) {
        link.classList.add(s.active)
      } else {
        link.classList.remove(s.active)
      }
    })
  }, [currentPath])

  const handleSignOut = async () => {
    const response = await signOut({
      redirect: true,
    })
  }

  return (
    <div className={clsx('container', s.root)}>
      <div className={s.headerMenu}>
        <div className={s.content}>
          <Link link={null} className={s.link}>
            <span className={s.underlineAnimation} onClick={handleSignOut}>
              Sign Out
            </span>
          </Link>
        </div>
      </div>

      <div className={s.headline}>
        Welcome {data?.customer?.firstName + ' ' + data?.customer?.lastName}
      </div>
      <ul className={s.menu}>
        <li>
          <Link
            className={s.link}
            link={{
              url: '/account/dashboard',
            }}
          >
            <Button variant="primary">Dashboard</Button>
          </Link>
        </li>
        <li>
          <Link className={s.link} link={{ url: '/account/my-orders' }}>
            <Button variant="primary">My Orders</Button>
          </Link>
        </li>
        <li>
          <Link className={s.link} link={{ url: '/account/profile' }}>
            <Button variant="primary">Profile</Button>
          </Link>
        </li>
      </ul>

      <div className={s.content}>
        {props.modules &&
          props.modules.length > 0 &&
          props.modules.map((component, index) => {
            return (
              <Module
                {...component}
                __typename={
                  component.contentTypeAlias.charAt(0).toUpperCase() +
                  component.contentTypeAlias.slice(1)
                }
                key={index}
                lcp={
                  props.modules
                    .filter((x) => x.__typename !== 'Spacer')
                    .findIndex((x) => x === component) < 2
                }
              />
            )
          })}
      </div>
    </div>
  )
}

export default M57GeneralComponent
